import { render, staticRenderFns } from "./InventoryDefaultValueForm.vue?vue&type=template&id=44ca39ed&scoped=true&"
import script from "./InventoryDefaultValueForm.vue?vue&type=script&lang=js&"
export * from "./InventoryDefaultValueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ca39ed",
  null
  
)

export default component.exports